<section>
	<figure>
		<corepark-logo width="17.5rem" />
	</figure>
</section>
<section>
	<div class="form-container">
		<h6>Hotel Link | Sign in</h6>
		<router-outlet />
	</div>
</section>
